import React from "react";
import {connect} from "react-redux";
import DataProtection from "../components/DataProtection";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

class DataProtectionContainer extends React.Component {
    render() {
        return (
            <div>
                <DataProtection />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataProtectionContainer);


// WEBPACK FOOTER //
// ./src/container/DataProtectionContainer.js